import api from "@/config/api"
import { withLoading } from "@/store/helpers"
import { clearRuntimeCaches } from "@/pwa/cache"
import { reconnectCable } from "@/utils/cable"

// Динамический импорт router чтобы избежать циклической зависимости
// (router/guard.js импортирует store, store импортирует router)
let routerInstance = null
import("@/router").then((m) => {
  routerInstance = m.default
})

export default {
  namespaced: true,
  state: () => ({
    currentUser: {},
    impersonator: null,
    impersonationExpiresAt: null,
    loading: false,
  }),
  mutations: {
    setCurrentUser(state, user) {
      state.currentUser = user
      state.impersonator = user?.impersonator || null
      state.impersonationExpiresAt = user?.impersonation_expires_at || null
    },
    setLoading(state, loading) {
      state.loading = loading
    }
  },
  actions: {
    async fetchCurrentUser(context) {
      return withLoading(async () => {
        const response = await api.get("/current_user")
        context.commit("setCurrentUser", response.data)
        return response.data
      }, context)
    },

    async login(context, params) {
      return withLoading(async () => {
        const response = await api.post("/sessions", params)

        // Токен уже сохраняется в интерцепторе API
        // Проверяем, что токен сохранился
        const savedToken = localStorage.getItem('token')
        console.log('Токен сохранен в localStorage:', savedToken)

        context.commit("setCurrentUser", response.data)
        return response.data
      }, context)
    },

    async logout(context) {
      return withLoading(async () => {
        await api.delete("/sessions/logout")
        localStorage.removeItem('token')
        await clearRuntimeCaches()
        context.commit("setCurrentUser", {})
      }, context)
    },

    async updateProfile(context, params) {
      return withLoading(async () => {
        const response = await api.put("/current_user/update_profile", params)
        context.commit("setCurrentUser", response.data)
      }, context)
    },

    async requestPasswordReset(context, { email }) {
      return withLoading(async () => {
        await api.post("/password_resets", { email })
      }, context)
    },

    async performPasswordReset(context, { token, password }) {
      return withLoading(async () => {
        await api.post("/password_resets/confirm", { token, password })
      }, context)
    },

    async uploadAvatar(context, blob) {
      return withLoading(async () => {
        const formData = new FormData()
        formData.append("image", blob, "avatar.jpg")
        const response = await api.post("/avatar", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        context.commit("setCurrentUser", { ...context.state.currentUser, avatar_url: response.data.avatar_url })
      }, context)
    },

    async registerOrganization(context, params) {
      return withLoading(async () => {
        await api.post("/organizations/register", params)
      }, context)
    },

    async deleteAvatar(context) {
      return withLoading(async () => {
        await api.delete("/avatar")
        context.commit("setCurrentUser", { ...context.state.currentUser, avatar_url: null })
      }, context)
    },

    async markUpdatesAsRead(context) {
      try {
        await api.delete("/update_changes_users/mark_all_read")
      } catch (e) {}
      context.commit("setCurrentUser", { ...context.state.currentUser, updates: [] })
    },

    async impersonate(context, { userId }) {
      return withLoading(async () => {
        const response = await api.post("/maestro/impersonations", { user_id: userId })

        const original = localStorage.getItem("token")
        if (original) {
          localStorage.setItem("original_token", original)
        }
        localStorage.setItem("token", response.data.token)
        localStorage.setItem("impersonation_expires_at", response.data.expires_at)
        // Сервер опознаёт соединение один раз, при подключении: без переподъёма
        // подписка продолжила бы слушать поток маэстро, а не сотрудника.
        reconnectCable()

        await context.dispatch("fetchCurrentUser")
        if (routerInstance) {
          routerInstance.push({ name: "Schedules" })
        }
      }, context)
    },

    async stopImpersonation(context, { reason = "manual" } = {}) {
      return withLoading(async () => {
        try {
          await api.delete("/maestro/impersonations/current", { params: { reason } })
        } catch (_) {
          // токен мог уже истечь — продолжаем фолбэк
        }

        const original = localStorage.getItem("original_token")
        if (original) {
          localStorage.setItem("token", original)
        }
        localStorage.removeItem("original_token")
        localStorage.removeItem("impersonation_expires_at")
        reconnectCable()

        await context.dispatch("fetchCurrentUser")
        if (routerInstance) {
          routerInstance.push({ name: "MaestroDashboard", query: { tab: "users" } })
        }
      }, context)
    }
  },
  getters: {
    features: (state) => {
      return state.currentUser?.features || []
    },
    isImpersonating: (state) => Boolean(state.impersonator)
  }
}
